import { useSelector } from "react-redux";
import { AppStore } from "../../store";
import { LoanOfferState } from "../../types/loan-offer";
import { selectLoanOfferState } from "./loan-offer.slice";

export const useGetLoanOfferState = () => {
  return useSelector<AppStore, LoanOfferState>(selectLoanOfferState);
};
